import { Box, Card } from '@redbubble/design-system';
import React, { useMemo } from 'react';

import { CheckoutButton } from './CheckoutButton';
import styles from './OrderSummary.module.scss';
import { OrderSummaryContext } from './orderSummaryContext';
import { DigitalShipping, Shipping } from './Shipping';

export interface SummaryProps {
  loading: boolean;
  children?: React.ReactNode;
}

export const OrderSummary = ({ loading, children }: SummaryProps) => {
  const value = useMemo(() => ({ loading }), [loading]);

  return (
    <OrderSummaryContext.Provider value={value}>
      {/* the section didn't use the <h2> as the aria label, so I had to specify it in aria-label */}
      <section className={styles.wrapper} aria-label="order summary">
        {/* The text is for accessibility purposes, it serves as the section title for screen readers */}
        <Card className={styles.card}>
          <Box className={styles.cardBody}>{children}</Box>
        </Card>
      </section>
    </OrderSummaryContext.Provider>
  );
};

OrderSummary.CheckoutButton = CheckoutButton;
OrderSummary.DigitalShipping = DigitalShipping;
OrderSummary.Shipping = Shipping;
